<template>
  <div class="countdown">
    <div v-if="days" class="">
      <div class="">
        {{ `${days} Dia(s) - ${hours}:${minutes}:${seconds}` }}
      </div>
    </div>
    <div v-else>
      <div class="">
        {{ `${hours}:${minutes}:${seconds}` }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    date: null,
    campanha: Object,
  },
  data() {
    return {
      now: Math.trunc(new Date().getTime() / 1000),
      event: new Date(this.date),
    }
  },
  mounted() {
    const _self = this
    window.setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000)
      if (
        this.campanha.cam_campanha_status_id == 3 &&
        !this.finish &&
        this.calculatedDate - this.now <= 0
      ) {
        _self.finish = true
        _self.$emit('onFinish')
      }
    }, 1000)
  },
  computed: {
    secondCount() {
      return this.calculatedDate - this.now
    },
    calculatedDate() {
      return Math.trunc(Date.parse(this.event) / 1000) + 10800
    },
    seconds() {
      if (this.secondCount < 0) return 0
      return this.secondCount % 60
    },
    minutes() {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60) % 60
    },
    hours() {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60 / 60) % 24
    },
    days() {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60 / 60 / 24)
    },
  },
  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    },
  },
}
</script>
<style lang="scss">
.countdown {
  display: flex;
  justify-content: center;
  &__block {
    text-align: center;
    padding: 0px 15px;
    position: relative;
    &:first-child {
      padding-left: 0;
      .countdown__digit {
        &:before {
          display: none;
        }
      }
    }
    &:last-child {
      padding-right: 0;
    }
  }
  &__text {
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  &__digit {
    line-height: 1;
    margin-bottom: 5px;
    &:before {
      content: ':';
      position: absolute;
      left: -5px;
    }
  }
}
</style>
